import React from "react";
import clsx from "clsx";

import { IGroup } from "../../../state";
import Modal from "../../../atoms/Modal";
import Toast from "../../Toast";

import styles from "./ModalEditGroup.module.scss";

export type Props = {
  group: IGroup | null;
  onClose: () => void;
  onSave: (group: IGroup) => void;
  handleDelete?: () => void;
};

const ModalEditGroup: React.FC<Props> = ({
  group,
  onClose,
  onSave,
  handleDelete,
}) => {
  const [nameGroup, setNameGroup] = React.useState(group?.name || "");
  const [showMsg, setShowMsg] = React.useState<{
    text: string;
    type: string;
  }>({
    text: "",
    type: "",
  });

  return (
    <Modal onClose={onClose} className={styles.customModal}>
      <p className={styles.customModal__label}>グループ名を編集</p>
      <input
        className={styles.customModal__input}
        type="text"
        value={nameGroup}
        onChange={e => setNameGroup(e.target.value)}
      />
      <div className={styles.customModal__actions}>
        <button
          className={clsx(styles.btnCancel, !handleDelete && "w-50")}
          onClick={onClose}
        >
          キャンセル
        </button>
        <button
          className={clsx(styles.btnSave, !handleDelete && "w-50")}
          onClick={() => {
            if (nameGroup.length !== 0) onSave({ ...group!, name: nameGroup! });
            else
              setShowMsg({
                text: "グループ名を記入してください",
                type: "error",
              });
          }}
        >
          更新
        </button>
        {handleDelete && (
          <button className={styles.btnDelete} onClick={handleDelete}>
            削除
          </button>
        )}
      </div>

      {showMsg.text && (
        <Toast
          onClose={() =>
            setShowMsg({
              text: "",
              type: "",
            })
          }
          message={showMsg}
        />
      )}
    </Modal>
  );
};

export default ModalEditGroup;
